import Vue from 'vue'
import Router from 'vue-router'


const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err =>
        err
    )
};

Vue.use(Router)

const Profile = () => import(/* webpackChunkName: "profile" */ '@views/profile');
const Login = () => import(/* webpackChunkName: "login" */ '@auth/Login.vue');
const Landing = () => import(/* webpackChunkName: "landing" */ '@/src/views/landing.vue');
const Home = () => import(/* webpackChunkName: "home" */ '@/src/views/home.vue');
const Analysis = () => import(/* webpackChunkName: "analysis" */ '@/src/views/analysis.vue');
const PageNotFound = () => import(/* webpackChunkName: "pagenotfound" */  '@/src/views/pagenotfound.vue');
const About = () => import(/* webpackChunkName: "about" */  '@/src/views/about.vue');
export default new Router({
    routes: [{
        path: '/home',
        name: 'home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },{
        path: '/',
        name: 'default',
        component: Landing
    },{
        path: '/analysis',
        name: 'analysis',
        component: Analysis,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {
            requiresAuth: true
        }
    }, {
        path: '/login',
        name: 'login',
        component: Login
    }, {
        path: '/about',
        name: 'about',
        component: About
    }, {
        path: "/*",
        name: 'notfound',
        component: PageNotFound
    }]

})
